<template>
  <div>
    <!-- Title -->
    <div class="content">
      <h2 class="subtitle">Pregled mjesečne prisutnosti - Tijana</h2>
    </div>

    <!-- Tabs -->
    <div class="tabs is-centered is-medium no-print">
      <ul>
        <li :class="{ 'is-active': true }">
          <a>Izaberi mjesec</a>
        </li>
      </ul>
    </div>

    <!-- Time Span -->
    <div class="content">
      <date-picker
        v-model="time3"
        @input="monthChosen"
        type="month"
      ></date-picker>
    </div>

    <!-- Tabs -->
    <div class="tabs is-centered is-medium no-print">
      <ul>
        <li :class="{ 'is-active': true }">
          <a>Izaberi zaposlenog</a>
        </li>
      </ul>
    </div>

    <!-- zaposleni -->
    <div slot="content">
      <div>
        <div class="field">
          <label class="label no-print">Zaposleni</label>
          <div class="control">
            <vue-select
              class="has-background-info-light"
              @option:selected="employeeSelected"
              type="text"
              label="name"
              :clearable="false"
              :options="employees"
              v-model="selectedEmployee"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="base-demo">
      <vue-table-dynamic :params="params" @cell-click="tableCellClicked"
        ><template v-slot:column-6="{ props }">
          <span
            :style="{
              color: props.cellData.color,
              'text-decoration': props.cellData.decoration,
              cursor: props.cellData.cursor,
            }"
            >{{ props.cellData.value }}</span
          > </template
        ><template v-slot:column-7="{ props }">
          <span
            :style="{
              color: props.cellData.color,
              'text-decoration': props.cellData.decoration,
              cursor: props.cellData.cursor,
            }"
            >{{ props.cellData.value }}</span
          >
        </template></vue-table-dynamic
      >
    </div>
  </div>
</template>

<script>
import UserService from "../../services/user.service";
import ReportService from "../../services/report.service";
import VueTableDynamic from "vue-table-dynamic";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import {
  getDateFromTicks,
  maskIfEquealsValue,
  isWorkingDayFromDate,
  getStatusCodeFromStatusId,
  addDays,
} from "../../_helpers/arrangers";

// import { getDateFromTicks } from "../../_helpers/arrangers";

const colors = [
  "#363636",
  "#046FDB",
  "#F85252",
  "#8B54E4",
  "#F07B3B",
  "#3ba272",
];

export default {
  name: "MonthlyPresence",
  components: {
    VueTableDynamic,
    DatePicker,
  },
  data() {
    return {
      tabSelector: 0,
      filterSelector: 0,
      departmentData: null,
      departments: [],
      employees: [],
      dailyLogs: [],
      statuses: [],
      selectedDailyLog: null,
      selectedName: null,
      selectedEmployee: null,
      selectedMonth: 0,
      selectedYear: 0,
      numberOfElementsThatNeedToBeRecalculated: 0,
      time3: null,
      params: {
        data: [
          [
            "Index",
            "Datum",
            "Radni dan",
            "Dolazak",
            "Kašnjenje",
            "Odlazak",
            "Izlasci",
            "Odmor/Doručak",
            "Radni sati",
            "Prekovremeno",
            "Status",
          ],
        ],
        header: "row",
        enableSearch: true,
        border: true,
        stripe: true,
        wordWrap: "break-word",
        whiteSpace: "normal",
        columnWidth: [
          { column: 0, width: "7%" },
          { column: 2, width: 80 },
        ],
      },
    };
  },
  mounted() {
    this.time3 = new Date();
    this.monthChosen(this.time3);
    this.getDepartments();
    this.getStatuses();
  },
  methods: {
    tableCellClicked(row_id, column_id, cell_data) {
      if (column_id == 2) {
        // console.log(jedan);
        console.log(column_id);
        console.log(cell_data);
        console.log(this.params.data[row_id]);
      }
      if (column_id == 5) {
        this.selectedDailyLog = this.dailyLogs[row_id - 1];
        this.selectedName = this.params.data[row_id][2];
        this.$modal.show("edit-outside-event-modal");
      }
    },
    monthChosen(mnth) {
      console.log(mnth);
      this.selectedMonth = mnth.getMonth() + 1;
      this.selectedYear = mnth.getFullYear();
      console.log(this.selectedMonth);
      console.log(this.selectedYear);
    },
    employeeSelected(emp) {
      this.getData(emp.id, this.selectedMonth, this.selectedYear);
    },
    getDepartments() {
      UserService.getDepartments().then((response) => {
        // reset ui
        // console.log(response.data);
        this.departmentData = response.data;
        this.arrangeSectors(response.data);
        this.arrangeEmployees(response.data);
      });
    },
    arrangeSectors(data) {
      data.forEach((element) => {
        this.departments.push({
          name: element.name,
          id: element.departmentId,
        });
      });
      // console.log(this.departments);
    },
    arrangeEmployees(data) {
      data.forEach((element) => {
        element.employee.forEach((emp) => {
          this.employees.push({
            name: emp.firstName + " " + emp.lastName,
            id: emp.employeeId,
          });
        });
      });
    },
    proba(date) {
      console.log(date);
    },
    resetUi() {
      this.params.data = [
        [
          "Index",
          "Datum",
          "Radni dan",
          "Dolazak",
          "Kašnjenje",
          "Odlazak",
          "Izlasci",
          "Odmor/Doručak",
          "Radni sati",
          "Prekovremeno",
          "Status",
        ],
      ];
      this.dailyLogs = [];
    },
    getStatuses() {
      ReportService.GetStatuses().then((response) => {
        this.statuses = response.data;
      });
    },
    recalculateLog(element) {
      if (element.didIstartedYesterday && element.didIstayedTillTomorrow) {
        // rec
        ReportService.GetEarliestPedestrianEntryByEmployeeIdAndDate(
          new Date(element.logDate),
          element.employeeId
        ).then((response) => {
          // arrival time override
          this.dotOrArrow = true;
          element.arrivalTimeGeneral = this.tijanize(
            response.data.accessTime,
            "T07:00:00"
          );

          console.log(response.data.accessTime);
          if (response.data.accessTime === undefined) {
            console.log("BINGO BONGO");
          }
          ReportService.GetEarliestPedestrianExitByEmployeeIdAndDate(
            addDays(new Date(element.logDate), 1),
            element.employeeId
          ).then((response) => {
            // departure time override
            element.departureTimeGeneral = this.tijanize(
              response.data.accessTime,
              "T15:00:00"
            );
            this.numberOfElementsThatNeedToBeRecalculated--;
            console.log("paja");
            console.log(this.numberOfElementsThatNeedToBeRecalculated);
            console.log(this.dailyLogs);
            if (this.numberOfElementsThatNeedToBeRecalculated == 0) {
              this.launchPaja();
            }
          });
        });
      } else if (element.didIstartedYesterday) {
        // rec
        ReportService.GetEarliestPedestrianEntryByEmployeeIdAndDate(
          new Date(element.logDate),
          element.employeeId
        ).then((response) => {
          // arrival time override
          this.dotOrArrow = true;
          console.log(response.data.accessTime);
          if (response.data.accessTime === undefined) {
            ReportService.GetLatestPedestrianEntryByEmployeeIdAndDate(
              addDays(new Date(element.logDate), -1),
              element.employeeId
            ).then((response) => {
              //arrival time double override
              this.dotOrArrow = false;
              element.arrivalTimeGeneral = this.tijanize(
                response.data.accessTime,
                "T07:00:00"
              );
              this.numberOfElementsThatNeedToBeRecalculated--;
              console.log("paja");
              console.log(this.numberOfElementsThatNeedToBeRecalculated);
              console.log(this.dailyLogs);
              if (this.numberOfElementsThatNeedToBeRecalculated == 0) {
                this.launchPaja();
              }
            });
          } else {
            element.arrivalTimeGeneral = this.tijanize(
              response.data.accessTime,
              "T07:00:00"
            );
            this.numberOfElementsThatNeedToBeRecalculated--;
            console.log("paja");
            console.log(this.numberOfElementsThatNeedToBeRecalculated);
            console.log(this.dailyLogs);
            if (this.numberOfElementsThatNeedToBeRecalculated == 0) {
              this.launchPaja();
            }
          }
        });
      } else if (element.didIstayedTillTomorrow) {
        ReportService.GetEarliestPedestrianExitByEmployeeIdAndDate(
          addDays(new Date(element.logDate), 1),
          element.employeeId
        ).then((response) => {
          // departure time override
          element.departureTimeGeneral = this.tijanize(
            response.data.accessTime,
            "T15:00:00"
          );
          this.numberOfElementsThatNeedToBeRecalculated--;
          console.log("paja");
          console.log(this.numberOfElementsThatNeedToBeRecalculated);
          console.log(this.dailyLogs);
          if (this.numberOfElementsThatNeedToBeRecalculated == 0) {
            this.launchPaja();
          }
        });
      }
    },

    tijanize(input, wish) {
      let output = "";
      input ? (output = input.split("T")[0] + wish) : (output = null);

      return output;
    },

    tijanizeNumber(input, wish) {
      let output = "";
      console.log("input:", input);
      if (input > 0) {
        output = getDateFromTicks(wish);
      }

      console.log(output);
      return output;
    },

    getLateHoursFromTicks(element) {
      let result = maskIfEquealsValue(
        this.tijanizeNumber(element.lateWorkhours, 0), //        getDateFromTicks(element.lateWorkhours),
        "00:00:00"
      );
      return result;
    },

    launchPaja() {
      console.log("SUPER PAJA");

      let ndx = 1;

      // total workhours
      let totalLateThisMonth = 0;
      let totalWorkhoursThisMonth = 0;
      let totalOvertimeThisMonth = 0;

      // populate table
      this.dailyLogs.forEach((element) => {
        totalLateThisMonth += element.lateWorkhours;
        totalWorkhoursThisMonth += element.totalWorkhoursThisDay;
        totalOvertimeThisMonth += element.overtimeWorkhours;
        // izračunaj status
        let statusCode = getStatusCodeFromStatusId(
          element.statusId,
          element.statusIdOverride,
          this.$store.state.general.statuses
        );
        let status = statusCode;
        if (element.logDay === 0 && statusCode.startsWith("SN")) {
          status = "  ";
        }

        // ovo ide tek kasnije, kada se izračuna da je paja 0
        this.params.data.push([
          // "Index"
          ndx++,
          // "Datum",
          new Date(element.logDate).toLocaleDateString("sr-latn-cs", {
            weekday: "short",
          }) +
            ", " +
            new Date(element.logDate).toLocaleDateString("sr-latn-cs"),
          // "Radni dan",
          isWorkingDayFromDate(new Date(element.logDate)) ? "✅" : "❌",
          // "Dolazak",
          this.calculateStartedYesterdayTime(element),
          //"Kašnjenje",
          this.getLateHoursFromTicks(element),
          // maskIfEquealsValue(
          //   getDateFromTicks(element.lateWorkhours),
          //   "00:00:00"
          // ),
          //"Odlazak",
          this.calculateStayesTillTomorrowTime(element),
          // "Izlasci",
          {
            value: element.outsideEvent.length,
            id: `${1}`,
            color: element.outsideEvent.length > 0 ? colors[1] : colors[0],
            decoration: element.outsideEvent.length > 0 ? "underline" : "none",
            cursor: element.outsideEvent.length > 0 ? "zoom-in" : "default",
          },
          // "Odmor/Doručak",
          {
            value: element.insideEvent.length,
            id: `${1}`,
            color: element.insideEvent.length > 0 ? colors[1] : colors[0],
            decoration: element.insideEvent.length > 0 ? "underline" : "none",
            cursor: element.insideEvent.length > 0 ? "zoom-in" : "default",
          },
          // "Radni sati"
          maskIfEquealsValue(
            this.tijanizeNumber(element.totalWorkhoursThisDay, 252000000000), // 07:00:00
            "00:00:00"
          ),
          // "Prekovremeno"
          maskIfEquealsValue(
            this.tijanizeNumber(element.overtimeWorkhours, 0),
            "00:00:00"
          ),
          // "Status",
          status,
        ]);
      });

      // dodajemo sumarni row
      this.params.data.push([
        "",
        "TOTAL:",
        "",
        "",
        maskIfEquealsValue(getDateFromTicks(totalLateThisMonth), "00:00:00"),
        "",
        {
          value: "",
          id: `${1}`,
          color: colors[1],
          decoration: "none",
          cursor: "default",
        },
        {
          value: "",
          id: `${1}`,
          color: colors[1],
          decoration: "none",
          cursor: "default",
        },
        maskIfEquealsValue(
          this.tijanizeNumber(totalWorkhoursThisMonth, 0),
          "00:00:00"
        ),
        maskIfEquealsValue(
          this.tijanizeNumber(totalOvertimeThisMonth, 0),
          "00:00:00"
        ),
        "",
      ]);
    },

    getData() {
      ReportService.GetMonthlyPresenceReviewByEmployeeIdAndMonth(
        this.selectedEmployee.id,
        this.selectedMonth,
        this.selectedYear
      ).then((response) => {
        console.log(response);

        // reset ui
        this.resetUi();

        // recalculate logs
        this.numberOfElementsThatNeedToBeRecalculated = 0;
        let elementsToRecalculate = [];

        // find elements that need to be recalculated
        response.data.forEach((element) => {
          if (element.didIstartedYesterday || element.didIstayedTillTomorrow) {
            this.numberOfElementsThatNeedToBeRecalculated++;
            elementsToRecalculate.push(element);
          }
        });

        // recalculate those elements
        elementsToRecalculate.forEach((etr) => {
          console.log(etr.logDate);
          this.recalculateLog(etr);
        });

        console.log("to recalculate:");
        console.log(this.numberOfElementsThatNeedToBeRecalculated);

        // populate table
        response.data.forEach((element) => {
          this.dailyLogs.push(element);
        });

        if (this.numberOfElementsThatNeedToBeRecalculated == 0) {
          this.launchPaja();
        }
      });
    },

    calculateStartedYesterdayTime(element) {
      if (element.didIstartedYesterday) {
        return (
          maskIfEquealsValue(
            new Date(
              this.tijanize(element.arrivalTimeGeneral, "T07:00:00")
            ).toLocaleTimeString("sr-latn-cs"),
            "01:00:00"
          ) + (this.dotOrArrow ? "." : "⬅️")
        );
      } else {
        return maskIfEquealsValue(
          new Date(
            this.tijanize(element.arrivalTimeGeneral, "T07:00:00")
          ).toLocaleTimeString("sr-latn-cs"),
          "01:00:00"
        );
      }
    },

    calculateStayesTillTomorrowTime(element) {
      if (element.didIstayedTillTomorrow) {
        return (
          "➡️" +
          maskIfEquealsValue(
            new Date(
              this.tijanize(element.departureTimeGeneral, "T15:00:00")
            ).toLocaleTimeString("sr-latn-cs"),
            "01:00:00"
          )
        );
      } else {
        return maskIfEquealsValue(
          new Date(
            this.tijanize(element.departureTimeGeneral, "T15:00:00")
          ).toLocaleTimeString("sr-latn-cs"),
          "01:00:00"
        );
      }
    },
  },
};
</script>
